import { useApiGetQuery, useApiMutation } from 'utils/queryClient'

export const devicesQueryKey = type => ['devices', type]

export const useDevices = (type, options = {}) =>
  useApiGetQuery({
    defaultValue: [],
    endpoint: `/devices?type=${type}`,
    queryKey: devicesQueryKey(type),
    options,
  })

export const useDesktopDevices = (options = {}) =>
  useDevices('desktop', options)

export const useServerDevices = (options = {}) =>
  useDevices('server', options)

export const useUpdateDevice = (id, options = {}) =>
  useApiMutation(`/devices/${id}`, 'patch', options)
